import { Utils } from "../../../../../../../services/utils.service";
import { DataCollection } from "../../../../../../infrastructure/datacollection";
import { DataContainerService } from "../../../../../../infrastructure/datacontainer.service";
import { RequestTypes } from "../../../../../../infrastructure/enums";
import { TransportData } from "../../../../../../infrastructure/transportdata";

export class AshaPostMasterFetchRequest {
  public static readonly FetchRequestType: string = "asha_post_fetch_request";
  asha_post_master_ids: number[] = [];
  zone_ids: number[] = [];
  district_ids: number[] = [];
  block_ids: number[] = [];
  bcm_post_ids: number[] = [];
  phc_ids: number[] = [];
  sc_ids: number[] = [];
  village_ids: number[] = [];
  under_supervision: number[] = [];

  public MergeIntoTransportData = (td: TransportData) => {
    let coll = DataContainerService.GetInstance().GetOrCreateCollection(
      td.MainData,
      AshaPostMasterFetchRequest.FetchRequestType,
    ) as DataCollection;
    coll.Entries.push(this);
  };

  public FormulateTransportData = () => {
    let td = Utils.GetInstance().CreateNewTransportData(RequestTypes.Fetch);
    this.MergeIntoTransportData(td);

    return td;
  };
}
export class AshaPostNameFetchRequest {
  public static readonly FetchRequestType: string =
    "asha_post_name_fetch_request";
  asha_post_master_ids: number[] = [];
  zone_ids: number[] = [];
  district_ids: number[] = [];
  block_ids: number[] = [];
  bcm_post_ids: number[] = [];
  phc_ids: number[] = [];
  sc_ids: number[] = [];
  village_ids: number[] = [];
  under_supervision: number[] = [];
  af_post_ids: number[] = [];

  public MergeIntoTransportData = (td: TransportData) => {
    let coll = DataContainerService.GetInstance().GetOrCreateCollection(
      td.MainData,
      AshaPostNameFetchRequest.FetchRequestType,
    ) as DataCollection;
    coll.Entries.push(this);
  };

  public FormulateTransportData = () => {
    let td = Utils.GetInstance().CreateNewTransportData(RequestTypes.Fetch);
    this.MergeIntoTransportData(td);

    return td;
  };
}
